'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'starship';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e039';
var svgPathData = 'M448 80a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 368c106 0 192-86 192-192S554 64 448 64c-83.8 0-155.1 53.7-181.3 128.6l-83.4 11.4-1.7-1.7-42.3-42.3 60.7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40L40 80C17.9 80 0 97.9 0 120s17.9 40 40 40l76.7 0 46.7 46.7-36.8 5C104.5 214.8 88 233.7 88 256s16.5 41.2 38.6 44.2l36.8 5-46.7 46.7-76.7 0c-22.1 0-40 17.9-40 40s17.9 40 40 40l160 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-60.7 0 42.3-42.3 1.7-1.7 83.4 11.4C292.9 394.3 364.2 448 448 448zM128.8 227.6l132.9-18.1C258 224.4 256 240 256 256s2 31.6 5.7 46.5L128.8 284.4C114.6 282.5 104 270.3 104 256s10.6-26.5 24.8-28.4zM40 96l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 144c-13.3 0-24-10.7-24-24S26.7 96 40 96zM16 392c0-13.3 10.7-24 24-24l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 416c-13.3 0-24-10.7-24-24zM390.4 256a57.6 57.6 0 1 1 115.2 0 57.6 57.6 0 1 1 -115.2 0zM520 256a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarship = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;